<template>
  <div
    class="category-selector selector"
    :class="{ missing: !classified.category && showWarnings }"
  >
    <div class="pa-block">
      <h3 class="selector-title">Type d'annonce</h3>
      <div class="pa-block__inner">
        <div
          v-for="(group, idx) in getSettings.categories.filter(
            (group) =>
              group.categories.filter(
                (category) =>
                  classified.profil == 'proflib' ||
                  category.hide_from_recruiter !== true
              ).length
          )"
          v-bind:key="idx"
          class="group selector"
          :class="{ missing: !classified.category && showWarnings }"
        >
          <fieldset>
            <legend class="title" v-html="group.name"></legend>
            <div
              v-for="(cat, idx) in group.categories"
              v-bind:key="idx"
              class="pa-block__row"
              :class="{
                active: category == cat.term_id,
                inactive: category != cat.term_id,
              }"
            >
              <input
                :id="'category-' + cat.slug"
                :value="cat.term_id"
                name="category"
                type="radio"
                v-model="category"
                v-if="
                  classified.profil == 'proflib' ||
                  cat.hide_from_recruiter !== true
                "
              />
              <label
                :for="'category-' + cat.slug"
                v-if="
                  classified.profil == 'proflib' ||
                  cat.hide_from_recruiter !== true
                "
              >
                {{ cat.name }}
              </label>
            </div>
            <!-- .pa-block__row -->
          </fieldset>
        </div>
        <!-- .group -->
      </div>
      <!-- .pa-block__inner -->
      <div class="required" :if="!classified.category">Champ non renseigné</div>
    </div>
    <!-- .pa-block -->
  </div>
  <!-- .category-selector -->
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "category-selector",
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getSettings"]),
    category: {
      get() {
        return this.classified.category;
      },
      set(category) {
        this.$store.commit("setCategory", category);
      },
    },
  },
};
</script>
